interface ShorewoodSealProps {
  /**
   * Legacy prop from the previous inline-SVG seal. Kept on the API
   * surface so existing call sites compile without changes, but it has
   * no effect now that the seal is a raster image.
   */
  spinPaddle?: boolean
  /** Tailwind sizing & layout classes applied to the root element. */
  className?: string
  /**
   * Accessibility label. When provided, the seal is announced with
   * this label. When omitted, the seal is treated as decorative.
   */
  ariaLabel?: string
}

/**
 * The Shorewood brand mark — the cream "SHOREWOOD · EST. 1902" emblem
 * (arched wordmark, sun over water, crossed paddles) mounted on a round
 * deepwater plate. The mark itself is a single cream color, so the plate
 * is what keeps it legible on the portal's paper backgrounds as well as
 * the dark auth screens; do not render the bare PNG on a light surface.
 * The component API is unchanged so every call site (Header, login
 * pages, the spinner, etc.) continues to work without modification.
 */
const ShorewoodSeal = ({ className, ariaLabel }: ShorewoodSealProps) => {
  const isDecorative = !ariaLabel
  return (
    <span
      role={isDecorative ? undefined : 'img'}
      aria-label={ariaLabel}
      aria-hidden={isDecorative || undefined}
      className={`${className ?? ''} inline-flex items-center justify-center rounded-full bg-deepwater ring-1 ring-gold/40 overflow-hidden`.trim()}
    >
      <img
        src="/shorewood-logo.png"
        alt=""
        aria-hidden="true"
        className="w-[74%] h-auto object-contain"
        draggable={false}
      />
    </span>
  )
}

export default ShorewoodSeal
